
import { ModalBase } from "./ModalBase";

function InfoModal({
    title,
    subtitle,
    infoStage,
    onSkipPress,
    onNextPress,
    showModal
}: Readonly<{
    title: string,
    subtitle: string,
    infoStage: number,
    onSkipPress: () => void,
    onNextPress: () => void,
    showModal: boolean,

}>) {
    return (
        <ModalBase
            open={showModal}
            title={title}
            subtitle={subtitle}
            rightBtnTxt={'Next'} 
            leftBtnTxt={'Skip'}
            onLeftBtnPress={onSkipPress}
            onRightBtnPress={onNextPress}
            currentIndex={infoStage}
        />
    )
}


export default InfoModal
